<form class="form-group edit-process" [formGroup]="type">
  <div class="card" *ngIf="!caseCreationComboTabVisible">
    <div class="card-body">
      <h1 class="dg-txt-primary dg-h-18">
        {{ "Create_case.Create_case" | translate }}
      </h1>

      <div class="col-md-4">
        <mat-label class="required-field">Type Selection</mat-label>

        <ng-select
          appearance="fill"
          appendTo="body"
          [items]="typeList"
          bindLabel="optionText"
          formControlName="typeSelect"
          (change)="onValueChange($event)"
        >
        </ng-select>
      </div>
    </div>
  </div>
  <div *ngIf="this.type?.controls.typeSelect.value?.optionValue == 1">
    <div class="card" *ngIf="!(data && data?.length > 0); else dialogTmplt">
      <div class="card-body">
        <!-- <h1 class="dg-txt-primary dg-h-18">
      {{ "Create_case.Create_case" | translate }}
    </h1> -->

        <ng-container *ngTemplateOutlet="mainFormTmplt"></ng-container>
        <div class="col-md-12">
          <mat-card-actions class="mat-card-actions dg-btn">
            <ng-container *ngTemplateOutlet="actionButtonsTmplt"></ng-container>
          </mat-card-actions>
        </div>
      </div>
    </div>
  </div>
  <ng-template #dialogTmplt>
    <!-- <h2 mat-dialog-title>{{ "Create_case.Create_case" | translate }}</h2> -->
    <mat-dialog-content>
      <ng-container *ngTemplateOutlet="mainFormTmplt"></ng-container>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <ng-container *ngTemplateOutlet="actionButtonsTmplt"></ng-container>
    </mat-dialog-actions>
  </ng-template>

  <!-- RESULBEL TEMPLATE -->
  <ng-template #mainFormTmplt>
    <form class="mt-4 createCase" [formGroup]="createCase">
      <div class="row" *ngIf="isDiscomEnabledTP">
        <div class="col-md-3">
          <mat-form-field>
            <mat-label>{{ "Create_case.Discom" | translate }} </mat-label>
            <div class="top-margin">
              <input disabled type="text" matInput formControlName="disccom" />
            </div>
          </mat-form-field>
        </div>
      </div>
      <div
        class="row"
        *ngIf="this.type?.controls.typeSelect.value?.optionValue != 3"
      >
        <div class="col-md-3">
          <mat-label class="required-field dark-grey ng-select-label"
            >{{ "Create_case.Department" | translate }}
          </mat-label>
          <ng-select
            [items]="deptList"
            bindLabel="optionText"
            [(ngModel)]="selectedDepartmentId"
            (click)="onClickDepartment()"
            placeholder="Department"
            formControlName="department"
            (change)="onChangeDepartment()"
          >
          </ng-select>
        </div>

        <div class="col-md-3">
          <mat-label class="required-field dark-grey ng-select-label">
            {{ "Create_case.Section" | translate }}
          </mat-label>
          <ng-select
            [items]="sectionList"
            bindLabel="optionText"
            (click)="onClickSection()"
            [(ngModel)]="selectedSection"
            placeholder="Section"
            formControlName="section"
            (change)="onChangeSectionAndRole()"
          >
          </ng-select>
        </div>

        <div class="col-md-3">
          <mat-label class="required-field dark-grey ng-select-label">
            {{ "Create_case.Role" | translate }}
          </mat-label>
          <ng-select
            #myRole
            [items]="roleList"
            bindLabel="optionText"
            [(ngModel)]="selectedRole"
            placeholder="Role"
            formControlName="role"
            (change)="onChangeSectionAndRole()"
          >
            <ng-template ng-option-tmp let-item="item">
              <div
                [ngClass]="{
                  'hide-option': !isSectionSelected
                }"
              >
                {{ item.optionText }}
              </div>
            </ng-template>
          </ng-select>
        </div>
        <div class="col-md-3 position-relative">
          <mat-label class="required-field dark-grey ng-select-label">
            {{ "Create_case.Process" | translate }}</mat-label
          >
          <ng-select
            #processSelect
            [items]="processList"
            placeholder="Process"
            formControlName="process"
            bindLabel="subName"
            [(ngModel)]="selectedAttribute"
            class="process-select"
          >
          </ng-select>
          <button
            type="button"
            class="search-button mt-4 pt-3"
            (click)="openDialog()"
            mat-icon-button
            color="primary"
            aria-label="search icon button"
            *ngIf="fromCaseCorrbool == false"
          >
            <mat-icon>search</mat-icon>
          </button>
        </div>
        <!--  <div class="col-md-3">
        <mat-label class="dark-grey ng-select-label">{{ "Create_case.Confidentiality" | translate }}
        </mat-label>
        <ng-select [items]="confidentialityList" bindLabel="optionText" [(ngModel)]="selectedconfidentiality"
          placeholder="confidentiality" formControlName="confidentiality">
        </ng-select>
      </div> -->
      </div>
      <div class="col-md-12">
        <div class="top-margin">
          <mat-label class="required-field dark-grey ng-select-label">{{
            "Create_case.Description" | translate
          }}</mat-label>
        </div>
        <mat-form-field class="mt-2">
          <textarea
            matInput
            appearance="fill"
            rows="4"
            cols="300"
            formControlName="description"
            [maxlength]="maxChars"
            [(ngModel)]="desc"
          ></textarea>
          <mat-error>{{
            "Create_case.Description_error" | translate
          }}</mat-error>
        </mat-form-field>
        <label class="nopadding clrlbl">
          {{ "Create_case.Characters_Left" | translate }}
          {{ maxChars - desc?.length }}</label
        >
      </div>
      <div class="row">
        <p class="text-color">
          {{ "Create_case.Note" | translate }}
        </p>
      </div>
    </form>
  </ng-template>

  <ng-template #actionButtonsTmplt>
    <button mat-raised-button *ngIf="!fromCaseCorrbool" (click)="onReset()">
      {{ "Create_case.Reset" | translate }}
    </button>
    <button
      mat-raised-button
      *ngIf="fromCaseCorrbool || this.data?.[0]?.appTypeId == '3'"
      [mat-dialog-close]="true"
    >
      {{ "Create_case.Cancel" | translate }}
    </button>
    <button
      *ngIf="this.type?.controls.typeSelect.value?.optionValue != 3"
      mat-raised-button
      (click)="onSubmit()"
      color="primary"
      [disabled]="!createCase.valid"
    >
      {{ "Create_case.Create" | translate }}
    </button>
    <button
      *ngIf="this.type?.controls.typeSelect.value?.optionValue == 3"
      color="primary"
      mat-raised-button
      (click)="onNextStep(1)"
      class="actions-button"
      [disabled]="this.createCase?.controls?.description?.invalid"
    >
      {{ "dg-publish-config.Proceed" | translate }}
    </button>
    <!-- <div class="action-icon align-icon mt-3">
       
          </div> -->
  </ng-template>
  <div
    class="card"
    *ngIf="this.type?.controls.typeSelect.value?.optionValue == 2"
  >
    <app-generic-approval [fromWorkflow]="true"></app-generic-approval>
  </div>
  <div
    class="card"
    *ngIf="this.type?.controls.typeSelect.value?.optionValue == 3"
  >
    <mat-stepper
      linear
      #stepper
      [(selectedIndex)]="selectedIndex"
      (selectionChange)="onStepChange($event)"
    >
      <form [formGroup]="createCase">
        <mat-step>
          <ng-template matStepLabel> Basic Details </ng-template>
          <div class="card-body">
            <!-- <h1 class="dg-txt-primary dg-h-18">
      {{ "Create_case.Create_case" | translate }}
    </h1> -->

            <form class="mt-4 createCase" [formGroup]="createCase">
              <div class="row">
                <div class="col-sm-4">
                  <dg-org-search
                    *ngIf="refreshOrg"
                    #orgSearch
                    [orgConfig]="orgConfig"
                    [selectedOrgs]="selectedOrgs"
                    (output)="getOrgData($event)"
                  ></dg-org-search>
                </div>
                <div class="col-md-4 common-form-field">
                  <mat-label class="ng-select-label required-field"
                    >Process</mat-label
                  >
                  <ng-select
                    class=""
                    [items]="processSelectList"
                    bindLabel="optionText"
                    formControlName="process"
                    placeholder="Please Select process"
                    appendTo="body"
                    [(ngModel)]="selectedAttribute"
                    (change)="onValueProcessChange($event)"
                  >
                  </ng-select>
                  <mat-error
                    class="ng-select-error"
                    *ngIf="
                      dynamic.controls['process']?.touched &&
                      dynamic.controls['process'].errors &&
                      dynamic.controls['process'].errors.required
                    "
                  >
                    Please select process
                  </mat-error>
                </div>
              </div>
              <div class="col-md-12">
                <div class="top-margin">
                  <mat-label class="required-field dark-grey ng-select-label">{{
                    "Create_case.Description" | translate
                  }}</mat-label>
                </div>
                <mat-form-field class="mt-2">
                  <textarea
                    matInput
                    appearance="fill"
                    rows="4"
                    cols="300"
                    formControlName="description"
                    [maxlength]="maxChars"
                    [(ngModel)]="desc"
                  ></textarea>
                  <mat-error>{{
                    "Create_case.Description_error" | translate
                  }}</mat-error>
                </mat-form-field>
                <label class="nopadding clrlbl">
                  {{ "Create_case.Characters_Left" | translate }}
                  {{ maxChars - desc?.length }}</label
                >
              </div>
              <div class="row">
                <p class="text-color">
                  {{ "Create_case.Note" | translate }}
                </p>
              </div>
            </form>

            <div class="col-md-12">
              <mat-card-actions class="mat-card-actions dg-btn">
                <ng-container
                  *ngTemplateOutlet="actionButtonsTmplt"
                ></ng-container>
              </mat-card-actions>
            </div>
          </div>
          <!-- <div class="action-icon align-icon mt-3">
            <button
              color="primary"
              mat-raised-button
              (click)="onNextStep(1)"
              class="actions-button"
              [disabled]="createCase.invalid"
            >
              {{ "dg-publish-config.Proceed" | translate }}
            </button>
          </div> -->
        </mat-step>
      </form>
      <form class="form-group edit-process" [formGroup]="dynamic">
        <mat-step [stepControl]="dynamic">
          <ng-template matStepLabel> Create Hierarchy </ng-template>
          <app-generic-approval
            [isGenericAprCase]="false"
            [process]="selectedAttribute"
            [caseDesc]="desc"
            (outputBack)="onNextStep(0)"
            (outputRefresh)="onHierarchyRefresh($event)"
          ></app-generic-approval>
          <!-- <app-workflow-configuration></app-workflow-configuration> -->

          <!-- <div class="action-icon align-icon">
            <button
              mat-raised-button
              (click)="onNextStep(0)"
              class="actions-button"
            >
              {{ "dg-publish-config.Back" | translate }}
            </button>

            <button
              color="primary"
              mat-raised-button
              class="actions-button ms-2"
              [disabled]="this.accessRows?.length == 0"
              (click)="onSubmit()"
            >
              Submit
            </button>
          </div> -->
        </mat-step>
      </form>
    </mat-stepper>
  </div>
</form>
